import { formatDate } from '@/services/date-formatter.service';
import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import { ITimeZone } from '../../../../types/ITimeZone';

import { Temporal } from 'temporal-polyfill';

interface DayCellProps {
	currentDay: Temporal.PlainDate;
	day: Temporal.PlainDate;
	timeZone: ITimeZone;
	today: Temporal.PlainDate;
}

export default function DayHeader({ today, day: d, timeZone, currentDay }: DayCellProps) {
	return (
		<Grid gridTemplateRows="auto auto 1fr" gap={1}>
			<Text variant="text-body-floating-label-medium" color="text-primary">
				{formatDate({
					date: new Date(d.toZonedDateTime(timeZone).toInstant().epochMilliseconds),
					timeZone: timeZone,
					weekday: 'short',
				})}
			</Text>
			<Flex alignItems="center" justifyContent="center">
				<Text
					variant="text-body-floating-label-medium"
					display="inline-flex"
					alignItems="center"
					justifyContent="center"
					position="relative"
					w="28px"
					h="28px"
					backgroundColor={d.equals(currentDay) ? 'secondary-default' : 'transparent'}
					color={d.equals(currentDay) ? 'text-light' : 'text-primary'}
					borderRadius="radii-1"
					transition="opacity.2s"
				>
					{d.equals(today) ? (
						<Box
							as="span"
							display="inline-block"
							position="absolute"
							bottom="4px"
							left="10px"
							width="10px"
							height="2px"
							background="currentColor"
							borderRadius="20px"
						></Box>
					) : null}
					{formatDate({
						date: new Date(d.toZonedDateTime(timeZone).toInstant().epochMilliseconds),
						timeZone: timeZone,
						day: '2-digit',
					})}
				</Text>
			</Flex>
		</Grid>
	);
}
